import { Step1FormModel } from '@shared/components/forms/new-loan/steps/step1/form/model'

export const step1InitialValues: Step1FormModel = {
	fio: null,
	phone: '',
	email: '',
	purpose: null,
}
